import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import Grid, { Half } from 'grid-styled'
import { translate } from 'react-i18next'
import CardContainer from '../../components/CardContainer'
import { Metrics, Fonts } from '../../Themes'
import Input from '../../components/Input'
import Button from '../../components/Button'
import { validateInput, validateForm } from '../../Utils/Validations'
import Dropdown from '../../components/Dropdown'
import { generateCommissionAgreement } from '../../sources/ContractsSource'
import Loader from '../../components/Loader'

const CustomGrid = styled(Grid)`
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};
  button {
    margin-top: ${Metrics.margins.base};
    float: right
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding: 0;
  }
`

const CustomHalf = styled(Half)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding: 0;
  }
`

const CustomCardContainer = styled(CardContainer)`
  height: 100%;
`

const List = styled.ul`
  padding-left: 0;
  list-style: none;
  ${Fonts.style.Text};

  li {
    margin: ${Metrics.margins.base} 0;
    padding-bottom: ${Metrics.margins.small};
    border-bottom: ${Metrics.borders.default};

    li {
      padding-bottom: 0;
      margin: ${Metrics.margins.small} 0;
      border-bottom: none;
    }
  }
`

const Terms = styled.div`
  ${Fonts.style.Text};
  margin-top: ${Metrics.margins.base};
`

const Title = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Label};
`

class CommissionAgreement extends Component {
  constructor (props) {
    super(props)
    let commissions = []
    let commission = 0.25
    while (commission <= 5) {
      commissions.push(`${commission}%`)
      commission += 0.25
    }
    this.state = {
      options: commissions,
      name: '',
      company: '',
      address: '',
      phoneNumber: '',
      email: '',
      transaction: '',
      commission: '',
      validity: '',
      generating: false,
      errors: {
        validity: '',
        transaction: '',
        name: '',
        company: '',
        address: '',
        phoneNumber: '',
        email: '',
        commission: ''
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.downloadFile = this.downloadFile.bind(this)
    this.handleValidate = this.handleValidate.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleChange (event, key) {
    const state = R.clone(this.state)
    state[key] = event.target.value
    this.setState(state)
  }

  handleSelect (el, key) {
    const state = R.clone(this.state)
    state[key] = el.toString()
    this.setState(state)
  }

  downloadFile () {
    const { errors } = this.state
    let validation = validateForm(this.state, errors)

    if (validation.valid) {
      this.setState({ generating: true }, () => {
        generateCommissionAgreement({
          name: this.state.name,
          company: this.state.company,
          address: this.state.address,
          phoneNumber: this.state.phoneNumber,
          email: this.state.email,
          transaction: this.state.transaction,
          commission: this.state.commission,
          validity: this.state.validity
        })
          .then(response => {
            this.setState({ generating: false })
            document.location = response.data.url
          })
          .catch(console.error)
      })
    } else {
      this.setState({ errors: validation.errors })
    }
  }

  handleValidate (name, value, errors) {
    let newErrors = validateInput(name, value, errors)
    this.setState({ errors: newErrors })
  }

  render () {
    const { t } = this.props
    const { errors } = this.state

    let transactionKeys = [
      {
        key: 'transaction',
        label: t('Transaction'),
        placeholder: t('Transaction Number')
      }
    ]

    let keys = [
      { key: 'name', label: t('Name'), placeholder: t('Name') },
      { key: 'company', label: t('Company'), placeholder: t('Company Name') },
      {
        key: 'address',
        label: t('Address'),
        placeholder: t('Company Address')
      },
      { key: 'phoneNumber', label: t('Phone'), placeholder: t('Phone Number') },
      { key: 'email', label: t('Email'), placeholder: t('E-mail') }
    ]

    let validityOptions = [
      'All future transactions between the Client and leads introduced by HvB',
      'The following transaction'
    ]

    return (
      <CustomCardContainer title={t('Commission Agreement')}>
        <Loader visible={this.state.generating} />
        <CustomHalf key={'validity'} noPadRight>
          <Title>{t('Validity')}</Title>
          <Dropdown
            placeholder={t('Select the validity of the transaction')}
            options={validityOptions}
            selectedOption={this.state.validity}
            handleSelect={el => this.handleSelect(el, 'validity')}
            error={errors.validity}
            handleBlur={event =>
              this.handleValidate('validity', this.state.validity, errors)}
            name={'validity'}
            required
          />
        </CustomHalf>

        <CustomHalf key={'commission'} noPadRight>
          <Title>{t('Commission')}</Title>
          <Dropdown
            placeholder={t('Select commission value')}
            options={this.state.options}
            selectedOption={this.state.commission}
            handleSelect={el => this.handleSelect(el, 'commission')}
            error={errors.commission}
            handleBlur={event =>
              this.handleValidate('commission', this.state.commission, errors)}
            name={'commission'}
            required
          />
        </CustomHalf>

        {this.state.validity === validityOptions[1] &&
          transactionKeys.map((el, index) => {
            return (
              <CustomHalf
                key={el.key}
                noPadLeft={index % 2 === 0}
                noPadRight={index % 2 === 1}>
                <Input
                  placeholder={el.placeholder}
                  name={el.key}
                  required
                  title={el.label}
                  value={this.state[el.key]}
                  handleChange={event => this.handleChange(event, el.key)}
                  error={errors[el.key]}
                  handleBlur={event =>
                    this.handleValidate(el.key, this.state[el.key], errors)}
                />
              </CustomHalf>
            )
          })}

        <CustomGrid>
          <Terms>
            <List>
              <li>
                <Title>Validity</Title>
                This Agreement is valid for{' '}
                <b>{this.state.validity || t('TRANSACTION VALIDITY')}</b>.
              </li>
              {this.state.validity === validityOptions[1] && (
                <li>
                  <Title>Transaction</Title>
                  Transaction Number:{' '}
                  <b>{this.state.transaction || t('TRANSACTION NUMBER')}</b>
                  <p>
                    The transaction number corresponds to the number allocated
                    by HvB to a specific property on the HvB web-based
                    portfolio.
                  </p>
                </li>
              )}
              <li>
                <Title>Commission</Title>
                <p>
                  The Client agrees to pay, in consideration for the
                  introduction made by HvB, a per deal Commission of{' '}
                  <b>{this.state.commission || t('COMMISSION')}</b> of the total
                  Transaction value directly to HvB in case of a successful
                  Transaction.
                </p>
                <p>
                  The Commission is to be paid to the account defined by HvB
                  latest 7 (seven) days after performance of the Investment.
                </p>
              </li>
              <li>
                <Title>Non-Circumvention and Non-Solicitation</Title>
                <p>
                  The Client agrees not to directly or indirectly circumvent HvB
                  and not to work/ deal/ transact with leads introduced by each
                  HvB at any time, without the knowledge and explicit permission
                  of HvB. This clause is valid indefinitely, and is not affected
                  by a possible cancellation of this Agreement.
                </p>
                <p>
                  In case of unauthorized circumvention or solicitation, in
                  addition to the Commission usually due to HvB for the
                  concerned Transaction, the violating Party is liable to pay to
                  HvB a penalty of 5% of the total Transaction value.
                </p>
                <p>
                  The payment of the penalty in no way transfers the ownership
                  of the lead the violating Party. Any further Transaction with
                  the concerned Client or Business Associate, without express
                  approval of the affected Party, shall trigger this penalty
                  anew.
                </p>
              </li>
              <li>
                <Title>Governing law and jurisdiction</Title>
                This Agreement shall in all respects be governed by and
                construed in accordance with Swiss law, without giving effect to
                its conflict of law principles. All disputes arising from or in
                connection with this Agreement, including disputes regarding its
                conclusion, validity, binding effect, amendment, breach,
                termination or rescission, shall be subject to the exclusive
                jurisdiction of courts of the Canton of Zurich.
              </li>
            </List>
          </Terms>
        </CustomGrid>

        {keys.map((el, index) => {
          return (
            <CustomHalf
              key={el.key}
              noPadLeft={index % 2 === 0}
              noPadRight={index % 2 === 1}>
              <Input
                placeholder={el.placeholder}
                name={el.key}
                required
                title={el.label}
                value={this.state[el.key]}
                handleChange={event => this.handleChange(event, el.key)}
                error={errors[el.key]}
                handleBlur={event =>
                  this.handleValidate(el.key, this.state[el.key], errors)}
              />
            </CustomHalf>
          )
        })}
        <CustomGrid>
          <Button label={t('Download')} onClick={this.downloadFile} />
        </CustomGrid>
      </CustomCardContainer>
    )
  }
}

CommissionAgreement.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  children: PropTypes.node
}

export default translate([ 'common', 'forms', 'admin' ], { wait: true })(
  CommissionAgreement
)



// WEBPACK FOOTER //
// ./src/pages/Agreements/CommissionAgreement.js